(function () {
  function initialiseGalleries(scope) {
    if (typeof window.Swiper !== 'function') return;
    scope.querySelectorAll('.signature-gallery .swiper3').forEach(function (gallery) {
      if (gallery.swiper) {
        gallery.swiper.update();
        return;
      }
      new window.Swiper(gallery, {
        slidesPerView: 1.15,
        spaceBetween: 10,
        grabCursor: true,
        navigation: {
          nextEl: gallery.querySelector('.swiper-button-next3'),
          prevEl: gallery.querySelector('.swiper-button-prev3')
        },
        breakpoints: {
          700: { slidesPerView: 2 },
          1100: { slidesPerView: 3 }
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseGalleries(document); });
  } else {
    initialiseGalleries(document);
  }
  window.addEventListener('load', function () { initialiseGalleries(document); });
  document.addEventListener('shopify:section:load', function (event) {
    initialiseGalleries(event.target);
  });
}());
